import { FETCH_OFFER_SUCCESS } from 'constants/index';
import type { Field } from 'models';
import { combineReducers } from 'redux';

type OffersAction = {
  type: typeof FETCH_OFFER_SUCCESS;
  payload: {
    entities: {
      fields: Record<string, Field>;
    };
  };
};

export const byId = (
  state: Record<string, Field> = {},
  action: OffersAction,
) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return fields;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: OffersAction) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return Object.keys(fields);
    default:
      return state;
  }
};

export const offersFields = combineReducers({ byId, ids });
